import { css } from 'lit';
import token from '../../utils/get-token';
import color from '../../utils/get-color-token';
import { typography } from '../../styles';

export function cardStyles() {
	return css`
		:host {
			--m-card-background-color: ${color('color-background-primary')};
		}

		.m-card {
			position: relative;
			display: flex;
			flex-direction: row;

			background-color: var(--m-card-background-color);
			border-radius: ${token('border-radius-s')};
			border: solid 1px ${color('color-divider')};
		}

		.m-card-flag {
			position: absolute;
			top: -1px;
			bottom: -1px;
			left: -1px;
			display: block;

			box-sizing: border-box;
			border: 1px solid var(--m-card-flag-color);
			background-color: var(--m-card-flag-color);
			width: ${token('border-thick')};
			border-top-left-radius: ${token('border-radius-s')};
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			border-bottom-left-radius: ${token('border-radius-s')};
		}

		.m-card-content {
			display: flex;
			flex: 1;
			flex-direction: column;
		}

		::slotted(m-divider) {
			--m-divider-margin-top: ${token('spacing-4')};
		}
	`;
}

export function cardBodyStyles() {
	return css`
		:host {
			--m-card-body-padding-x: ${token('spacing-4')};
			--m-card-body-padding-y: ${token('spacing-4')};
		}

		.m-card-body {
			padding: var(--m-card-body-padding-y) var(--m-card-body-padding-x);
		}
	`;
}

export function cardSubtitleStyles() {
	return css`
		:host {
			--m-card-subtitle-margin-top: ${token('spacing-2')};
			--m-card-subtitle-padding-x: ${token('spacing-4')};
			--m-card-subtitle-padding-y: 0;
		}

		.m-card-subtitle {
			${typography('body-md')};

			margin-block-start: var(--m-card-subtitle-margin-top);
			padding: var(--m-card-subtitle-padding-y) var(--m-card-subtitle-padding-x);

			color: ${color('color-text-tertiary')};
		}
	`;
}

export function cardTitleStyles() {
	return css`
		:host {
			--m-card-title-padding-x: ${token('spacing-4')};
			--m-card-title-padding-top: ${token('spacing-4')};
		}

		.m-card-title {
			padding: var(--m-card-title-padding-top) var(--m-card-title-padding-x) 0;

			${typography('heading-sm-bold')};
			color: ${color('color-text-primary')};
		}

		slot[name='leading']::slotted(*) {
			display: inline-flex;
			flex-flow: row nowrap;
			align-items: center;
			justify-content: center;
			pointer-events: none;
			margin-inline-end: ${token('spacing-1')};
		}
	`;
}
